import { SearchAdapter, SearchRequest, SearchResponse } from '@empathy/search-adapter';
import { Filter } from '@empathy/search-types';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { logger } from '../../../logger';
import { mapWishlistToResults } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { NO_RESULTS_ACTIONS_KEYS, NO_RESULTS_MUTATIONS_KEYS } from '../no-results.const';
import { NoResultsAction, NoResultsContext } from '../no-results.interfaces';

export class GetFallbackFiltersResultsAction implements NoResultsAction {

  actions = {
    [NO_RESULTS_ACTIONS_KEYS.getFallbackFiltersResults]: ({ commit, rootGetters, rootState }: NoResultsContext, filter: Filter): any => {
      const { wishlist } = rootState.core;
      const platformAdapter = container.get<SearchAdapter>(DEPENDENCIES.Adapter);
      const searchRequest = this.modifyRequestFilters(rootGetters[GETTERS_KEYS.search.searchRequest], filter);
      platformAdapter.search(searchRequest, { requestId: `fallback-filters-results-${ filter.id }` })
        .then((searchResponse: SearchResponse) => {
          mapWishlistToResults(wishlist, searchResponse.results);
          commit(NO_RESULTS_MUTATIONS_KEYS.setFallbackFiltersResults, { [filter.id]: searchResponse.results });
        })
        .catch(error => logger.error('Fallback filter results', error));
    }
  };

  private modifyRequestFilters(searchRequest: SearchRequest, filter: Filter): SearchRequest {
    return Object.assign({}, searchRequest, { filters: { [filter.facet.modelName]: [filter] } });
  }
}
